interface IProps {
    color?: string;
};

export const FooterUser = (props: IProps) => {
    const { color } = props;
    return (
        <svg width="25" height="25" viewBox="0 0 17 20"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_2769_3928" maskUnits="userSpaceOnUse" x="0" y="12" width="17" height="8">
                <path fillRule="evenodd" clipRule="evenodd" d="M0.5 12.4961H16.3399V19.8701H0.5V12.4961Z"
                    fill="white" />
            </mask>
            <g mask="url(#mask0_2769_3928)">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.421 13.9961C4.16 13.9961 2 14.7281 2 16.1731C2 17.6311 4.16 18.3701 8.421 18.3701C12.681 18.3701 14.84 17.6381 14.84 16.1931C14.84 14.7351 12.681 13.9961 8.421 13.9961M8.421 19.8701C6.462 19.8701 0.5 19.8701 0.5 16.1731C0.5 12.8771 5.021 12.4961 8.421 12.4961C10.38 12.4961 16.34 12.4961 16.34 16.1931C16.34 19.4891 11.82 19.8701 8.421 19.8701"
                    fill="#A5A5A5" />
            </g>
            <mask id="mask1_2769_3928" maskUnits="userSpaceOnUse" x="3" y="0" width="11" height="11">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.10986 0H13.7299V10.6186H3.10986V0Z"
                    fill="white" />
            </mask>
            <g mask="url(#mask1_2769_3928)">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.42089 1.428C6.27989 1.428 4.53789 3.169 4.53789 5.31C4.53089 7.444 6.25989 9.184 8.39189 9.192L8.42089 9.906V9.192C10.5609 9.192 12.3019 7.45 12.3019 5.31C12.3019 3.169 10.5609 1.428 8.42089 1.428M8.42089 10.619H8.3889C5.4669 10.61 3.09989 8.227 3.10989 5.307C3.10989 2.382 5.49189 0 8.42089 0C11.3489 0 13.7299 2.382 13.7299 5.31C13.7299 8.238 11.3489 10.619 8.42089 10.619"
                    fill="#A5A5A5" />
            </g>
        </svg>


    );
};